import { monitoringActionType } from '../../constants'

const initialState = {
  runs: { records: [], totalRecords: 0, currentPage: 1, totalPage: 1 },
  results: { records: [], totalRecords: 0, currentPage: 1, totalPage: 1 },
  coverage: null
}

export default (state = initialState, action) => {
  switch (action.type) {
    case monitoringActionType.FETCH_MONITORING_RUNS:
      return { ...state, runs: action.payload || initialState.runs }
    case monitoringActionType.FETCH_MONITORING_RESULTS:
      return { ...state, results: action.payload || initialState.results }
    case monitoringActionType.FETCH_MONITORING_COVERAGE:
      return { ...state, coverage: action.payload || null }
    default:
      return state
  }
}
